export default __webpack_public_path__ + "static/media/06.1e5c7fc9.jpg";